"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// 1/21/21 Requirements are identical to CA.
const CA_1 = __importDefault(require("./CA"));
exports.default = CA_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTUkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvanNvblNjaGVtYS9wcm9kdWN0cy9yZWdpb25TY2hlbWFzL01JLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsNENBQTRDO0FBQzVDLDhDQUFnQztBQUVoQyxrQkFBZSxZQUFZLENBQUMifQ==